// src/components/store/sections/newsletter/NewsletterV70GradientbannerIndigoPulse.tsx
"use client";

import React from "react";
import DynamicNewsletterVariant from "./DynamicNewsletterVariant";

export default function NewsletterV70GradientbannerIndigoPulse(props: any) {
  return (
    <DynamicNewsletterVariant
      variantNumber={70}
      archKey="gradient_banner"
      archLabel="Gradient Accent Banner"
      palName="IndigoPulse"
      grad="from-indigo-500 via-blue-600 to-violet-700"
      lightBg="bg-indigo-50"
      textCol="text-indigo-700"
      borderCol="border-indigo-200"
      btnCls="bg-indigo-600 hover:bg-indigo-700"
      hexCol="#6366f1"
      {...props}
    />
  );
}
